
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model'
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class contactData extends Vue {

    @Prop() value: OM.ContactData;
    @Prop() readonly: boolean;

}
